import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Lobby from './pages/Lobby';
import Battle from './pages/Battle';
import SoloMode from './pages/SoloMode';
import Join from './pages/Join';
import Import from './pages/Import';

function App() {
  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/lobby/:roomCode" element={<Lobby />} />
          <Route path="/battle/:roomCode" element={<Battle />} />
          <Route path="/solo" element={<SoloMode />} />
          <Route path="/join/:roomCode?" element={<Join />} />
          <Route path="/import" element={<Import />} />
          <Route path="/callback" element={<Import />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
